module.exports = __webpack_public_path__ + "img/bsh.b43fe1bb.png";